export default __webpack_public_path__ + "static/media/amobee-logo.01bc5a42.svg";